export default "__VITE_ASSET__1edb96ff__"